// source: accounts/protos/pangolin_dto.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */


var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var accounts_protos_plan_dto_pb = require('../../accounts/protos/plan_dto_pb.js');
goog.object.extend(proto, accounts_protos_plan_dto_pb);
goog.exportSymbol('proto.accounts.protos.ColorCode', null, global);
goog.exportSymbol('proto.accounts.protos.PangolinDTO', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.PangolinDTO = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accounts.protos.PangolinDTO, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.PangolinDTO.displayName = 'proto.accounts.protos.PangolinDTO';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.PangolinDTO.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.PangolinDTO.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.PangolinDTO} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.PangolinDTO.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    publicKeyHash: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    nickname: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    colorCode: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    timezone: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    onlineStatus: (f = jspb.Message.getBooleanField(msg, 6)) == null ? undefined : f,
    bandwidthUploadString: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
    bandwidthUploadUnits: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
    bandwidthDownloadString: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f,
    bandwidthDownloadUnits: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f,
    enableBandwidthControls: (f = jspb.Message.getBooleanField(msg, 11)) == null ? undefined : f,
    enableBufferbloatPrevention: (f = jspb.Message.getBooleanField(msg, 12)) == null ? undefined : f,
    menderPendingUpdateId: (f = jspb.Message.getField(msg, 13)) == null ? undefined : f,
    menderPendingUpdateName: (f = jspb.Message.getField(msg, 14)) == null ? undefined : f,
    menderPendingUpdateCreatedAt: (f = msg.getMenderPendingUpdateCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    menderPendingUpdateInstalled: (f = jspb.Message.getBooleanField(msg, 16)) == null ? undefined : f,
    menderPendingUpdatePopupDisplay: (f = jspb.Message.getBooleanField(msg, 17)) == null ? undefined : f,
    menderPendingUpdateVersion: (f = jspb.Message.getField(msg, 18)) == null ? undefined : f,
    menderFinishedUpdateId: (f = jspb.Message.getField(msg, 35)) == null ? undefined : f,
    menderFinishedUpdateName: (f = jspb.Message.getField(msg, 36)) == null ? undefined : f,
    menderFinishedUpdateCreatedAt: (f = msg.getMenderFinishedUpdateCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    menderFinishedUpdateVersion: (f = jspb.Message.getField(msg, 38)) == null ? undefined : f,
    menderVersion: (f = jspb.Message.getField(msg, 19)) == null ? undefined : f,
    menderRefreshedAt: (f = msg.getMenderRefreshedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    redirectModeBridgeEnabled: (f = jspb.Message.getBooleanField(msg, 46)) == null ? undefined : f,
    redirectModeUnicastEnabled: (f = jspb.Message.getBooleanField(msg, 21)) == null ? undefined : f,
    redirectModeUnicastTypeResponse: (f = jspb.Message.getBooleanField(msg, 22)) == null ? undefined : f,
    redirectModeUnicastTypeRequest: (f = jspb.Message.getBooleanField(msg, 23)) == null ? undefined : f,
    redirectModeUnicastNetworkInternet: (f = jspb.Message.getBooleanField(msg, 44)) == null ? undefined : f,
    redirectModeUnicastNetworkInternal: (f = jspb.Message.getBooleanField(msg, 45)) == null ? undefined : f,
    redirectModeBroadcastEnabled: (f = jspb.Message.getBooleanField(msg, 24)) == null ? undefined : f,
    redirectModeBroadcastHostGateways: (f = jspb.Message.getBooleanField(msg, 25)) == null ? undefined : f,
    redirectModeBroadcastHostHosts: (f = jspb.Message.getBooleanField(msg, 26)) == null ? undefined : f,
    redirectModeBroadcastHostAll: (f = jspb.Message.getBooleanField(msg, 27)) == null ? undefined : f,
    redirectModeBroadcastTypeResponse: (f = jspb.Message.getBooleanField(msg, 28)) == null ? undefined : f,
    redirectModeBroadcastTypeRequest: (f = jspb.Message.getBooleanField(msg, 29)) == null ? undefined : f,
    masqueradeEgress: (f = jspb.Message.getBooleanField(msg, 30)) == null ? undefined : f,
    scannerEnableScanMdns: (f = jspb.Message.getBooleanField(msg, 39)) == null ? undefined : f,
    scannerEnableScanNbios: (f = jspb.Message.getBooleanField(msg, 40)) == null ? undefined : f,
    scannerEnableScanNmap: (f = jspb.Message.getBooleanField(msg, 41)) == null ? undefined : f,
    scannerEnableScanRdns: (f = jspb.Message.getBooleanField(msg, 42)) == null ? undefined : f,
    scannerEnableScanUpnp: (f = jspb.Message.getBooleanField(msg, 43)) == null ? undefined : f,
    plans: (f = msg.getPlans()) && accounts_protos_plan_dto_pb.PlansDTO.toObject(includeInstance, f),
    updateActiveReleaseId: (f = jspb.Message.getField(msg, 32)) == null ? undefined : f,
    updateActiveUpgradeId: (f = jspb.Message.getField(msg, 33)) == null ? undefined : f,
    updateActiveRestoreId: (f = jspb.Message.getField(msg, 34)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.PangolinDTO}
 */
proto.accounts.protos.PangolinDTO.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.PangolinDTO;
  return proto.accounts.protos.PangolinDTO.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.PangolinDTO} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.PangolinDTO}
 */
proto.accounts.protos.PangolinDTO.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublicKeyHash(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 4:
      var value = /** @type {!proto.accounts.protos.ColorCode} */ (reader.readEnum());
      msg.setColorCode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimezone(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnlineStatus(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setBandwidthUploadString(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setBandwidthUploadUnits(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setBandwidthDownloadString(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setBandwidthDownloadUnits(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableBandwidthControls(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableBufferbloatPrevention(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setMenderPendingUpdateId(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setMenderPendingUpdateName(value);
      break;
    case 15:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setMenderPendingUpdateCreatedAt(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMenderPendingUpdateInstalled(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMenderPendingUpdatePopupDisplay(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setMenderPendingUpdateVersion(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setMenderFinishedUpdateId(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setMenderFinishedUpdateName(value);
      break;
    case 37:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setMenderFinishedUpdateCreatedAt(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setMenderFinishedUpdateVersion(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setMenderVersion(value);
      break;
    case 20:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setMenderRefreshedAt(value);
      break;
    case 46:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeBridgeEnabled(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeUnicastEnabled(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeUnicastTypeResponse(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeUnicastTypeRequest(value);
      break;
    case 44:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeUnicastNetworkInternet(value);
      break;
    case 45:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeUnicastNetworkInternal(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeBroadcastEnabled(value);
      break;
    case 25:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeBroadcastHostGateways(value);
      break;
    case 26:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeBroadcastHostHosts(value);
      break;
    case 27:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeBroadcastHostAll(value);
      break;
    case 28:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeBroadcastTypeResponse(value);
      break;
    case 29:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeBroadcastTypeRequest(value);
      break;
    case 30:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMasqueradeEgress(value);
      break;
    case 39:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setScannerEnableScanMdns(value);
      break;
    case 40:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setScannerEnableScanNbios(value);
      break;
    case 41:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setScannerEnableScanNmap(value);
      break;
    case 42:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setScannerEnableScanRdns(value);
      break;
    case 43:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setScannerEnableScanUpnp(value);
      break;
    case 31:
      var value = new accounts_protos_plan_dto_pb.PlansDTO;
      reader.readMessage(value,accounts_protos_plan_dto_pb.PlansDTO.deserializeBinaryFromReader);
      msg.setPlans(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdateActiveReleaseId(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdateActiveUpgradeId(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdateActiveRestoreId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.PangolinDTO.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.PangolinDTO.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.PangolinDTO} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.PangolinDTO.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {!proto.accounts.protos.ColorCode} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeBool(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeString(
      9,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeBool(
      11,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeBool(
      12,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeString(
      13,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getMenderPendingUpdateCreatedAt();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 16));
  if (f != null) {
    writer.writeBool(
      16,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 17));
  if (f != null) {
    writer.writeBool(
      17,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 18));
  if (f != null) {
    writer.writeString(
      18,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 35));
  if (f != null) {
    writer.writeString(
      35,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 36));
  if (f != null) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getMenderFinishedUpdateCreatedAt();
  if (f != null) {
    writer.writeMessage(
      37,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 38));
  if (f != null) {
    writer.writeString(
      38,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 19));
  if (f != null) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getMenderRefreshedAt();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 46));
  if (f != null) {
    writer.writeBool(
      46,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 21));
  if (f != null) {
    writer.writeBool(
      21,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 22));
  if (f != null) {
    writer.writeBool(
      22,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 23));
  if (f != null) {
    writer.writeBool(
      23,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 44));
  if (f != null) {
    writer.writeBool(
      44,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 45));
  if (f != null) {
    writer.writeBool(
      45,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 24));
  if (f != null) {
    writer.writeBool(
      24,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 25));
  if (f != null) {
    writer.writeBool(
      25,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 26));
  if (f != null) {
    writer.writeBool(
      26,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 27));
  if (f != null) {
    writer.writeBool(
      27,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 28));
  if (f != null) {
    writer.writeBool(
      28,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 29));
  if (f != null) {
    writer.writeBool(
      29,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 30));
  if (f != null) {
    writer.writeBool(
      30,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 39));
  if (f != null) {
    writer.writeBool(
      39,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 40));
  if (f != null) {
    writer.writeBool(
      40,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 41));
  if (f != null) {
    writer.writeBool(
      41,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 42));
  if (f != null) {
    writer.writeBool(
      42,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 43));
  if (f != null) {
    writer.writeBool(
      43,
      f
    );
  }
  f = message.getPlans();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      accounts_protos_plan_dto_pb.PlansDTO.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 32));
  if (f != null) {
    writer.writeString(
      32,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 33));
  if (f != null) {
    writer.writeString(
      33,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 34));
  if (f != null) {
    writer.writeString(
      34,
      f
    );
  }
};


/**
 * required string id = 1;
 * @return {string}
 */
proto.accounts.protos.PangolinDTO.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * required string public_key_hash = 2;
 * @return {string}
 */
proto.accounts.protos.PangolinDTO.prototype.getPublicKeyHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setPublicKeyHash = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearPublicKeyHash = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasPublicKeyHash = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string nickname = 3;
 * @return {string}
 */
proto.accounts.protos.PangolinDTO.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setNickname = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearNickname = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasNickname = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ColorCode color_code = 4;
 * @return {!proto.accounts.protos.ColorCode}
 */
proto.accounts.protos.PangolinDTO.prototype.getColorCode = function() {
  return /** @type {!proto.accounts.protos.ColorCode} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.accounts.protos.ColorCode} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setColorCode = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearColorCode = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasColorCode = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string timezone = 5;
 * @return {string}
 */
proto.accounts.protos.PangolinDTO.prototype.getTimezone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setTimezone = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearTimezone = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasTimezone = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool online_status = 6;
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.getOnlineStatus = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setOnlineStatus = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearOnlineStatus = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasOnlineStatus = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string bandwidth_upload_string = 7;
 * @return {string}
 */
proto.accounts.protos.PangolinDTO.prototype.getBandwidthUploadString = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setBandwidthUploadString = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearBandwidthUploadString = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasBandwidthUploadString = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string bandwidth_upload_units = 8;
 * @return {string}
 */
proto.accounts.protos.PangolinDTO.prototype.getBandwidthUploadUnits = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setBandwidthUploadUnits = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearBandwidthUploadUnits = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasBandwidthUploadUnits = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string bandwidth_download_string = 9;
 * @return {string}
 */
proto.accounts.protos.PangolinDTO.prototype.getBandwidthDownloadString = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setBandwidthDownloadString = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearBandwidthDownloadString = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasBandwidthDownloadString = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string bandwidth_download_units = 10;
 * @return {string}
 */
proto.accounts.protos.PangolinDTO.prototype.getBandwidthDownloadUnits = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setBandwidthDownloadUnits = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearBandwidthDownloadUnits = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasBandwidthDownloadUnits = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional bool enable_bandwidth_controls = 11;
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.getEnableBandwidthControls = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setEnableBandwidthControls = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearEnableBandwidthControls = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasEnableBandwidthControls = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional bool enable_bufferbloat_prevention = 12;
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.getEnableBufferbloatPrevention = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setEnableBufferbloatPrevention = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearEnableBufferbloatPrevention = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasEnableBufferbloatPrevention = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional string mender_pending_update_id = 13;
 * @return {string}
 */
proto.accounts.protos.PangolinDTO.prototype.getMenderPendingUpdateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setMenderPendingUpdateId = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearMenderPendingUpdateId = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasMenderPendingUpdateId = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string mender_pending_update_name = 14;
 * @return {string}
 */
proto.accounts.protos.PangolinDTO.prototype.getMenderPendingUpdateName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setMenderPendingUpdateName = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearMenderPendingUpdateName = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasMenderPendingUpdateName = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.Timestamp mender_pending_update_created_at = 15;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accounts.protos.PangolinDTO.prototype.getMenderPendingUpdateCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 15));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
*/
proto.accounts.protos.PangolinDTO.prototype.setMenderPendingUpdateCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearMenderPendingUpdateCreatedAt = function() {
  return this.setMenderPendingUpdateCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasMenderPendingUpdateCreatedAt = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional bool mender_pending_update_installed = 16;
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.getMenderPendingUpdateInstalled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setMenderPendingUpdateInstalled = function(value) {
  return jspb.Message.setField(this, 16, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearMenderPendingUpdateInstalled = function() {
  return jspb.Message.setField(this, 16, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasMenderPendingUpdateInstalled = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional bool mender_pending_update_popup_display = 17;
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.getMenderPendingUpdatePopupDisplay = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setMenderPendingUpdatePopupDisplay = function(value) {
  return jspb.Message.setField(this, 17, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearMenderPendingUpdatePopupDisplay = function() {
  return jspb.Message.setField(this, 17, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasMenderPendingUpdatePopupDisplay = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional string mender_pending_update_version = 18;
 * @return {string}
 */
proto.accounts.protos.PangolinDTO.prototype.getMenderPendingUpdateVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setMenderPendingUpdateVersion = function(value) {
  return jspb.Message.setField(this, 18, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearMenderPendingUpdateVersion = function() {
  return jspb.Message.setField(this, 18, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasMenderPendingUpdateVersion = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional string mender_finished_update_id = 35;
 * @return {string}
 */
proto.accounts.protos.PangolinDTO.prototype.getMenderFinishedUpdateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setMenderFinishedUpdateId = function(value) {
  return jspb.Message.setField(this, 35, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearMenderFinishedUpdateId = function() {
  return jspb.Message.setField(this, 35, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasMenderFinishedUpdateId = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional string mender_finished_update_name = 36;
 * @return {string}
 */
proto.accounts.protos.PangolinDTO.prototype.getMenderFinishedUpdateName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setMenderFinishedUpdateName = function(value) {
  return jspb.Message.setField(this, 36, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearMenderFinishedUpdateName = function() {
  return jspb.Message.setField(this, 36, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasMenderFinishedUpdateName = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional google.protobuf.Timestamp mender_finished_update_created_at = 37;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accounts.protos.PangolinDTO.prototype.getMenderFinishedUpdateCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 37));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
*/
proto.accounts.protos.PangolinDTO.prototype.setMenderFinishedUpdateCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 37, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearMenderFinishedUpdateCreatedAt = function() {
  return this.setMenderFinishedUpdateCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasMenderFinishedUpdateCreatedAt = function() {
  return jspb.Message.getField(this, 37) != null;
};


/**
 * optional string mender_finished_update_version = 38;
 * @return {string}
 */
proto.accounts.protos.PangolinDTO.prototype.getMenderFinishedUpdateVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setMenderFinishedUpdateVersion = function(value) {
  return jspb.Message.setField(this, 38, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearMenderFinishedUpdateVersion = function() {
  return jspb.Message.setField(this, 38, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasMenderFinishedUpdateVersion = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * optional string mender_version = 19;
 * @return {string}
 */
proto.accounts.protos.PangolinDTO.prototype.getMenderVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setMenderVersion = function(value) {
  return jspb.Message.setField(this, 19, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearMenderVersion = function() {
  return jspb.Message.setField(this, 19, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasMenderVersion = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional google.protobuf.Timestamp mender_refreshed_at = 20;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accounts.protos.PangolinDTO.prototype.getMenderRefreshedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 20));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
*/
proto.accounts.protos.PangolinDTO.prototype.setMenderRefreshedAt = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearMenderRefreshedAt = function() {
  return this.setMenderRefreshedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasMenderRefreshedAt = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional bool redirect_mode_bridge_enabled = 46;
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.getRedirectModeBridgeEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 46, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setRedirectModeBridgeEnabled = function(value) {
  return jspb.Message.setField(this, 46, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearRedirectModeBridgeEnabled = function() {
  return jspb.Message.setField(this, 46, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasRedirectModeBridgeEnabled = function() {
  return jspb.Message.getField(this, 46) != null;
};


/**
 * optional bool redirect_mode_unicast_enabled = 21;
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.getRedirectModeUnicastEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setRedirectModeUnicastEnabled = function(value) {
  return jspb.Message.setField(this, 21, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearRedirectModeUnicastEnabled = function() {
  return jspb.Message.setField(this, 21, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasRedirectModeUnicastEnabled = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional bool redirect_mode_unicast_type_response = 22;
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.getRedirectModeUnicastTypeResponse = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setRedirectModeUnicastTypeResponse = function(value) {
  return jspb.Message.setField(this, 22, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearRedirectModeUnicastTypeResponse = function() {
  return jspb.Message.setField(this, 22, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasRedirectModeUnicastTypeResponse = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional bool redirect_mode_unicast_type_request = 23;
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.getRedirectModeUnicastTypeRequest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setRedirectModeUnicastTypeRequest = function(value) {
  return jspb.Message.setField(this, 23, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearRedirectModeUnicastTypeRequest = function() {
  return jspb.Message.setField(this, 23, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasRedirectModeUnicastTypeRequest = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional bool redirect_mode_unicast_network_internet = 44;
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.getRedirectModeUnicastNetworkInternet = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 44, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setRedirectModeUnicastNetworkInternet = function(value) {
  return jspb.Message.setField(this, 44, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearRedirectModeUnicastNetworkInternet = function() {
  return jspb.Message.setField(this, 44, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasRedirectModeUnicastNetworkInternet = function() {
  return jspb.Message.getField(this, 44) != null;
};


/**
 * optional bool redirect_mode_unicast_network_internal = 45;
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.getRedirectModeUnicastNetworkInternal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 45, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setRedirectModeUnicastNetworkInternal = function(value) {
  return jspb.Message.setField(this, 45, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearRedirectModeUnicastNetworkInternal = function() {
  return jspb.Message.setField(this, 45, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasRedirectModeUnicastNetworkInternal = function() {
  return jspb.Message.getField(this, 45) != null;
};


/**
 * optional bool redirect_mode_broadcast_enabled = 24;
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.getRedirectModeBroadcastEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setRedirectModeBroadcastEnabled = function(value) {
  return jspb.Message.setField(this, 24, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearRedirectModeBroadcastEnabled = function() {
  return jspb.Message.setField(this, 24, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasRedirectModeBroadcastEnabled = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional bool redirect_mode_broadcast_host_gateways = 25;
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.getRedirectModeBroadcastHostGateways = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 25, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setRedirectModeBroadcastHostGateways = function(value) {
  return jspb.Message.setField(this, 25, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearRedirectModeBroadcastHostGateways = function() {
  return jspb.Message.setField(this, 25, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasRedirectModeBroadcastHostGateways = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional bool redirect_mode_broadcast_host_hosts = 26;
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.getRedirectModeBroadcastHostHosts = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 26, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setRedirectModeBroadcastHostHosts = function(value) {
  return jspb.Message.setField(this, 26, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearRedirectModeBroadcastHostHosts = function() {
  return jspb.Message.setField(this, 26, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasRedirectModeBroadcastHostHosts = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional bool redirect_mode_broadcast_host_all = 27;
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.getRedirectModeBroadcastHostAll = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 27, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setRedirectModeBroadcastHostAll = function(value) {
  return jspb.Message.setField(this, 27, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearRedirectModeBroadcastHostAll = function() {
  return jspb.Message.setField(this, 27, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasRedirectModeBroadcastHostAll = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional bool redirect_mode_broadcast_type_response = 28;
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.getRedirectModeBroadcastTypeResponse = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 28, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setRedirectModeBroadcastTypeResponse = function(value) {
  return jspb.Message.setField(this, 28, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearRedirectModeBroadcastTypeResponse = function() {
  return jspb.Message.setField(this, 28, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasRedirectModeBroadcastTypeResponse = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional bool redirect_mode_broadcast_type_request = 29;
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.getRedirectModeBroadcastTypeRequest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 29, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setRedirectModeBroadcastTypeRequest = function(value) {
  return jspb.Message.setField(this, 29, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearRedirectModeBroadcastTypeRequest = function() {
  return jspb.Message.setField(this, 29, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasRedirectModeBroadcastTypeRequest = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional bool masquerade_egress = 30;
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.getMasqueradeEgress = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 30, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setMasqueradeEgress = function(value) {
  return jspb.Message.setField(this, 30, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearMasqueradeEgress = function() {
  return jspb.Message.setField(this, 30, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasMasqueradeEgress = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional bool scanner_enable_scan_mdns = 39;
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.getScannerEnableScanMdns = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 39, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setScannerEnableScanMdns = function(value) {
  return jspb.Message.setField(this, 39, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearScannerEnableScanMdns = function() {
  return jspb.Message.setField(this, 39, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasScannerEnableScanMdns = function() {
  return jspb.Message.getField(this, 39) != null;
};


/**
 * optional bool scanner_enable_scan_nbios = 40;
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.getScannerEnableScanNbios = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 40, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setScannerEnableScanNbios = function(value) {
  return jspb.Message.setField(this, 40, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearScannerEnableScanNbios = function() {
  return jspb.Message.setField(this, 40, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasScannerEnableScanNbios = function() {
  return jspb.Message.getField(this, 40) != null;
};


/**
 * optional bool scanner_enable_scan_nmap = 41;
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.getScannerEnableScanNmap = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 41, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setScannerEnableScanNmap = function(value) {
  return jspb.Message.setField(this, 41, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearScannerEnableScanNmap = function() {
  return jspb.Message.setField(this, 41, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasScannerEnableScanNmap = function() {
  return jspb.Message.getField(this, 41) != null;
};


/**
 * optional bool scanner_enable_scan_rdns = 42;
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.getScannerEnableScanRdns = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 42, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setScannerEnableScanRdns = function(value) {
  return jspb.Message.setField(this, 42, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearScannerEnableScanRdns = function() {
  return jspb.Message.setField(this, 42, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasScannerEnableScanRdns = function() {
  return jspb.Message.getField(this, 42) != null;
};


/**
 * optional bool scanner_enable_scan_upnp = 43;
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.getScannerEnableScanUpnp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 43, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setScannerEnableScanUpnp = function(value) {
  return jspb.Message.setField(this, 43, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearScannerEnableScanUpnp = function() {
  return jspb.Message.setField(this, 43, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasScannerEnableScanUpnp = function() {
  return jspb.Message.getField(this, 43) != null;
};


/**
 * optional PlansDTO plans = 31;
 * @return {?proto.PlansDTO}
 */
proto.accounts.protos.PangolinDTO.prototype.getPlans = function() {
  return /** @type{?proto.PlansDTO} */ (
    jspb.Message.getWrapperField(this, accounts_protos_plan_dto_pb.PlansDTO, 31));
};


/**
 * @param {?proto.PlansDTO|undefined} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
*/
proto.accounts.protos.PangolinDTO.prototype.setPlans = function(value) {
  return jspb.Message.setWrapperField(this, 31, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearPlans = function() {
  return this.setPlans(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasPlans = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional string update_active_release_id = 32;
 * @return {string}
 */
proto.accounts.protos.PangolinDTO.prototype.getUpdateActiveReleaseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setUpdateActiveReleaseId = function(value) {
  return jspb.Message.setField(this, 32, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearUpdateActiveReleaseId = function() {
  return jspb.Message.setField(this, 32, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasUpdateActiveReleaseId = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional string update_active_upgrade_id = 33;
 * @return {string}
 */
proto.accounts.protos.PangolinDTO.prototype.getUpdateActiveUpgradeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setUpdateActiveUpgradeId = function(value) {
  return jspb.Message.setField(this, 33, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearUpdateActiveUpgradeId = function() {
  return jspb.Message.setField(this, 33, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasUpdateActiveUpgradeId = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional string update_active_restore_id = 34;
 * @return {string}
 */
proto.accounts.protos.PangolinDTO.prototype.getUpdateActiveRestoreId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.setUpdateActiveRestoreId = function(value) {
  return jspb.Message.setField(this, 34, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinDTO} returns this
 */
proto.accounts.protos.PangolinDTO.prototype.clearUpdateActiveRestoreId = function() {
  return jspb.Message.setField(this, 34, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinDTO.prototype.hasUpdateActiveRestoreId = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * @enum {number}
 */
proto.accounts.protos.ColorCode = {
  RED: 0,
  ORANGE: 1,
  YELLOW: 2,
  GREEN: 3,
  BLUE: 4,
  VIOLET: 5
};

goog.object.extend(exports, proto.accounts.protos);
